import Seo from '../components/Seo';
import Reveal from '../components/Reveal';
import { T } from '../i18n/copy';

export default function PrivacyPage({ lang }) {
  const t = T.privacy;
  return (
    <>
      <Seo lang={lang} title={T.meta.privacy.title[lang]} description={T.meta.privacy.desc[lang]} />
      <section data-header-theme="bone" data-testid="privacy-page" className="editorial-margins bg-bone py-12 md:py-16">
        <div className="flex items-center gap-3">
          <span className="inline-block h-2 w-2 bg-vermilion" aria-hidden="true" />
          <span className="eyebrow text-midnight/70">Navartha</span>
        </div>
        <Reveal className="mt-8">
          <h1 className="max-w-2xl font-tight font-semibold text-[clamp(2.2rem,4.4vw,3.8rem)] leading-[1.05] tracking-[-0.02em] text-midnight" data-testid="privacy-title">
            {t.title[lang]}
          </h1>
        </Reveal>
        <Reveal delay={0.1} className="mt-8 max-w-xl">
          <p className="text-base leading-relaxed text-midnight/70">{t.intro[lang]}</p>
        </Reveal>

        <div className="mt-16 border-t border-midnight/15" data-testid="privacy-sections">
          {t.sections[lang].map((s, i) => (
            <Reveal key={s.title} delay={0.04} testid={`privacy-section-${i}`}>
              <div className="grid grid-cols-1 gap-4 border-b border-midnight/10 py-8 md:grid-cols-12 md:py-10">
                <div className="md:col-span-4">
                  <span className="eyebrow text-steel-dark">0{i + 1}</span>
                  <h2 className="mt-2 text-[17px] font-medium leading-snug text-midnight">{s.title}</h2>
                </div>
                <p className="text-base leading-relaxed text-midnight/70 md:col-span-7">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12" testid="privacy-contact">
          <a href="mailto:hello@navartha.id" className="font-serif text-xl text-midnight underline decoration-vermilion decoration-1 underline-offset-8 transition-colors hover:text-vermilion md:text-2xl">
            hello@navartha.id
          </a>
        </Reveal>
      </section>
    </>
  );
}
